import request from '@/utils/request'

let RegionalApi = {
    /*地区风险管理列表*/
    indexRegion(data, errorback) {
        return request._post('/shop/setting.region/indexRegion', data, errorback);
    },
    /*地区风险管理添加*/
    addRegion(data, errorback) {
        return request._post('/shop/setting.region/addRegion', data, errorback);
    },
    /*地区风险管理修改*/
    editRegion(data, errorback) {
        return request._post('/shop/setting.region/editRegion', data, errorback);
    },
    /*地区风险管理删除*/
    deleteRegion(data, errorback) {
        return request._post('/shop/setting.region/deleteRegion', data, errorback);
    },
}
export default RegionalApi;


// WEBPACK FOOTER //
// ./src/api/Regional.js